import { AnalyticsEvent } from "./analyticsEvent"
class PageSizeInteractionEvent extends AnalyticsEvent {
    public dataPageSize: string;
    constructor(pageSize: string) {
        super();
        this.dataPageSize = pageSize;
    }
}
export { PageSizeInteractionEvent }